import {
    Box,
    Grid,
    Typography,
} from '@mui/material'

export const SMBankVirtualCollection: React.FC = () => {

    const list1 = [
        {
            'title': 'Agreement Number',
            'content': '123456789123'
        },
        {
            'title': 'Vehicle Number',
            'content': 'ABC8888'
        },
        {
            'title': 'Name',
            'content': 'Daniel **** *** ****'
        },
    ]

    const list2 = [
        {
            'title': 'Your UOB Bank Collection Account',
            'content': '68688123456789123'
        },
        {
            'title': 'Your AmBank Collection Account',
            'content': '88812345678912'
        },
    ]

    const renderItem = (title: string, content: string, key: string) => {
        return (
            <Grid key={key} item xs={12}>
                <Grid container columnSpacing={0} rowSpacing={0}>
                    <Grid item xs={6}>
                        <Typography fontSize={16} fontWeight={500} color={'#6B6B6B'}>
                            {title}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography fontSize={16} fontWeight={600} color={'#141F39'}>
                            {content}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        )
    }

    // ======================= VIEWS
    return (
        <Box sx={{
            width: '100%',
            backgroundColor: '#FFF8E7',
            paddingTop: '60px',
            paddingBottom: '60px',
            paddingLeft: '240px',
            paddingRight: '240px'
        }}>
            <Typography fontSize={32} fontWeight={700} color={'#141F39'} textAlign={'center'}>
                Bank Virtual Collection Account
            </Typography>

            <Box sx={{
                marginTop: '48px',
                paddingLeft: '50px',
                paddingRight: '50px',
                paddingTop: '50px',
                paddingBottom: '50px',
                backgroundColor: '#FFFFFF',
                borderRadius: '10px'
            }}>
                <Grid container rowSpacing={1} columnSpacing={0}>
                    {list1.map((item, index) => {
                        return renderItem(list1[index]['title'], list1[index]['content'], 'key:' + index)
                    })}
                </Grid>

                <Box sx={{
                    width: '100%',
                    height: '1px',
                    backgroundColor: '#E4E4E4',
                    marginTop: '20px',
                    marginBottom: '20px'
                }}></Box>

                <Grid container rowSpacing={1} columnSpacing={0}>
                    {list2.map((item, index) => {
                        return renderItem(list2[index]['title'], list2[index]['content'], 'key:' + index)
                    })}
                </Grid>
            </Box>


        </Box>
    )
}

// ======================= EXPORT
export default SMBankVirtualCollection
